import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import { captcha } from '@/api/user';
import { checkDB } from '@/api/initdb';
import ForceGoogleBinding from '@/components/ForceGoogleBinding.vue';
export default {
  name: 'Login',
  components: {
    ForceGoogleBinding: ForceGoogleBinding
  },
  data: function data() {
    var checkUsername = function checkUsername(rule, value, callback) {
      if (value.length < 5) {
        return callback(new Error('请输入正确的用户名'));
      } else {
        callback();
      }
    };
    var checkPassword = function checkPassword(rule, value, callback) {
      if (value.length < 6) {
        return callback(new Error('请输入正确的密码'));
      } else {
        callback();
      }
    };
    return {
      curYear: 0,
      lock: 'lock',
      loginForm: {
        username: '',
        password: '',
        captcha: '',
        captchaId: '',
        googleCode: ''
      },
      rules: {
        username: [{
          validator: checkUsername,
          trigger: 'blur'
        }],
        password: [{
          validator: checkPassword,
          trigger: 'blur'
        }]
      },
      logVerify: '',
      picPath: '',
      showForceBinding: false,
      pendingUserInfo: {},
      pendingLoginData: {}
    };
  },
  created: function created() {
    this.loginVerify();
    this.curYear = new Date().getFullYear();
  },
  methods: _objectSpread(_objectSpread({}, mapActions('user', ['LoginIn'])), {}, {
    checkInit: function checkInit() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, _res$data;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return checkDB();
            case 1:
              res = _context.sent;
              if (res.code === 0) {
                if ((_res$data = res.data) !== null && _res$data !== void 0 && _res$data.needInit) {
                  _this.$store.commit('user/NeedInit');
                  _this.$router.push({
                    name: 'Init'
                  });
                } else {
                  _this.$message({
                    type: 'info',
                    message: '已配置数据库信息，无法初始化'
                  });
                }
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    login: function login() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var loginResult;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return _this2.LoginIn(_this2.loginForm);
            case 1:
              loginResult = _context2.sent;
              if (!(loginResult && loginResult.needGoogleBinding)) {
                _context2.next = 2;
                break;
              }
              _this2.pendingUserInfo = loginResult.userInfo;
              _this2.pendingLoginData = {
                token: loginResult.token,
                merchantGrade: loginResult.merchantGrade,
                merchantId: loginResult.merchantId
              };
              _this2.showForceBinding = true;
              return _context2.abrupt("return", false);
            case 2:
              return _context2.abrupt("return", loginResult);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    handleBindingSuccess: function handleBindingSuccess() {
      this.showForceBinding = false;
    },
    submitForm: function submitForm() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this3.$refs.loginForm.validate(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(v) {
                  var flag;
                  return regeneratorRuntime.wrap(function (_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        if (!v) {
                          _context3.next = 2;
                          break;
                        }
                        _context3.next = 1;
                        return _this3.login();
                      case 1:
                        flag = _context3.sent;
                        if (!flag) {
                          _this3.loginVerify();
                        }
                        _context3.next = 3;
                        break;
                      case 2:
                        _this3.$message({
                          type: 'error',
                          message: '请正确填写登录信息',
                          showClose: true
                        });
                        _this3.loginVerify();
                        return _context3.abrupt("return", false);
                      case 3:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    changeLock: function changeLock() {
      this.lock = this.lock === 'lock' ? 'unlock' : 'lock';
    },
    loginVerify: function loginVerify() {
      var _this4 = this;
      captcha({}).then(function (ele) {
        _this4.picPath = ele.data.picPath;
        _this4.loginForm.captchaId = ele.data.captchaId;
      });
    }
  })
};